import React, { useState } from "react";
import "./Work.scss";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";
import { images } from "../../constant";

let works = [
  {
    title: "Movie Search Filter",
    description: "Movies List Fetching From API",
    imgUrl: images.about01,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Simple-Movie-Search-Filter-Using-React`,
    tags: ["React Js", "All"],
  },
  {
    title: "Simple Quiz App",
    description: "Tech Stack used HTML,CSS,Javascript.",
    imgUrl: images.about02,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Simple-Quiz-Application-Using-JS`,
    tags: ["Javascript App",'All'],
  
  },
  {
    title: "WebPage Pre-loader ",
    description: "Tech Stack used HTML,CSS",
    imgUrl: images.about03,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Webpage-Pre-Loader`,
    tags: ["HTML/CSS", "All"],
  },
  {
    title: "Bg-Color Change Based on Input Value ",
    description: "Tech Stack used HTML,CSS",
    imgUrl: images.about04,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Auto-Color-Change-BasedOn-InputValue`,
    tags: ["HTML/CSS", "All"],
  },
  {
    title: "Vertical Side Testimonial ",
    description: "Tech Stack used HTML,CSS,Javascript",
    imgUrl: images.about01,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Vertical-Slide-Testimonial`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "PopUp-Message ",
    description: "Tech Stack used HTML,CSS",
    imgUrl: images.about02,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/PopUp-Message`,
    tags: ["HTML/CSS", "All"],
  },
  {
    title: "Stop Watch",
    description: "Tech Stack used HTML,CSS,Javascript",
    imgUrl: images.about03,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Stop-Watch-Using-JS`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Notes App",
    description: "Tech Stack used HTML,CSS,Javascript",
    imgUrl: images.about04,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Notes-App`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Animation Effect",
    description: "Tech Stack used HTML,CSS",
    imgUrl: images.about01,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Animation-Effect-Using-CSS`,
    tags: ["Animation", "All"],
  },
  {
    title: "Expandable Card",
    description: "Framer Motion Package by using attrctive animation",
    imgUrl: images.about02,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Expandable-Card-Animation-Using-ReactJS`,
    tags: ["React JS", "All"],
  },
  {
    title: "Scroll to Top Behaviour",
    description: "Tech Stack used HTML,CSS,Javascript.",
    imgUrl: images.about03,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Scroll-To-Top-Behavior`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Digital Clock",
    description: "Tech Stack used HTML,CSS,Javascript.",
    imgUrl: images.about04,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Digital-Clock`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Drag & Drop Image Upload",
    description: "Tech Stack used HTML,CSS,Javascript.",
    imgUrl: images.about01,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Drag-Drop-Image-Upload`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Text To Speech Convertor",
    description: "Tech Stack used HTML,CSS,Javascript.",
    imgUrl: images.about02,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Text-To-Speech-Convertor`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Auto-Typing Text",
    description:
      "Tech Stack used HTML,CSS,Javascript and Auto type CDN Link Imported.",
    imgUrl: images.about03,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Auto_Type_Text-Generator`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Show/Hide Password Generator",
    description: "Tech Stack used HTML,CSS,Javascript",
    imgUrl: images.about04,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Show_Hide-Password-Generator`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Responsive Web Application",
    description: "Tech Stack used HTML,CSS,Javascript",
    imgUrl: images.about01,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Youtube-Clone-By-Using-HTML_CSS_JS`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Responsive Nav Bar",
    description: "Tech Stack used HTML,CSS",
    imgUrl: images.about02,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Responsive-Navbar-with-Animation`,
    tags: ["HTML/CSS", "All"],
  },
  {
    title: "To-Do-List Application",
    description: "Tech Stack used HTML,CSS,Javascript",
    imgUrl: images.about03,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Simple-To-Do-List-application`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "Simple Responsive Portfolio ",
    description: "Tech Stack used HTML,CSS,Javascript",
    imgUrl: images.about04,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/portfolio-application`,
    tags: ["Javascript App", "All"],
  },
  {
    title: "GSAP Animation ",
    description: "Using GreenSock Javascript Library",
    imgUrl: images.about01,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/GSAP-Animation-1`,
    tags: ["Animation", "All"],
  },
  {
    title: "Cookiee Animation ",
    description: "Using GreenSock Javascript Library",
    imgUrl: images.about02,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Gsap-Cookie-Animation`,
    tags: ["Animation", "All"],
  },
  {
    title: "Cookiee ANimation ",
    description: "Using GreenSock Javascript Library",
    imgUrl: images.about02,
    projectLink: `https://github.com/kodiyarasuc`,
    codeLink: `https://github.com/kodiyarasuc/Gsap-Cookie-Animation`,
    tags: ["Animation", "All"],

  },
];

const Work = () => {
  let [activeFilter, setActiveFilter] = useState("All");
  const [filterWork, setFilterWork] = useState(works);
  let [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };
  return (
    <div className="app__work">
      <h2 className="head-text">
        My Creative <span> Portfolio</span>Section
      </h2>

      <div className="app__work-filter">
        {["HTML/CSS", "Javascript App", "Animation", "React Js", "All"].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-filter-item app__flex p-text ${
                activeFilter === item ? "item-active" : ""
              }`}
            >
              {item}
            </div>
          )
        )}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img src={work.imgUrl} alt={work.title} />

              <motion.div 
                whileHover={{ opacity: [0,1] }}
                transition={{
                  duration: 0.5,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="app__work-hover app__flex"
              >
                <a
                  href={`${work.projectLink}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.5 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={`${work.codeLink}`} target="blank" rel="norefer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.5 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
